/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCalendarDay
 */
export interface UpdateCalendarDay {
    /**
     * 
     * @type {string}
     * @memberof UpdateCalendarDay
     */
    day: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCalendarDay
     */
    name: string;
}

/**
 * Check if a given object implements the UpdateCalendarDay interface.
 */
export function instanceOfUpdateCalendarDay(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "day" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function UpdateCalendarDayFromJSON(json: any): UpdateCalendarDay {
    return UpdateCalendarDayFromJSONTyped(json, false);
}

export function UpdateCalendarDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCalendarDay {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'day': json['day'],
        'name': json['name'],
    };
}

export function UpdateCalendarDayToJSON(value?: UpdateCalendarDay | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'day': value.day,
        'name': value.name,
    };
}

